import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const ThreeWLAWeekHeaderContainerStyled = styled.div`
  ${({ theme }) => css`
    display: grid;
    background-color: ${theme.colors.grey[200]};
    grid-template-columns: 40% 1fr 1fr 1fr 1fr;
    grid-template-rows: ${theme.spacings[800]};
  `}
`;

export const ThreeWLAColumnStyled = styled(Box).attrs({
  pt: { sm: '500' },
  pl: { sm: '500' },
})`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const CurrentWeekStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[800]};
    color: ${theme.colors.white};
    height: ${theme.spacings[600]};
    width: ${theme.spacings[600]};
    border-radius: ${theme.spacings[450]};
  `}
`;
